/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {CreateTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const createTile = (request:CreateTileRequest, options?: CashRequestOptions) => post<CreateTileRequest, CreateTileResponse>("/2.0/cash/create-tile", request, {...options, rejectOnError: true })